import { UserWithProviders } from "@/auth/types";

export const isFeideUser = (user: UserWithProviders) => {
  return user?.publicMetadata?.isFeideUser === true;
};

export const isFeideUserFromSession = (
  sessionClaims: CustomJwtSessionClaims | null | undefined,
): boolean => {
  return sessionClaims?.publicMeta?.isFeideUser === true;
};

export const ensureE164Format = (phone: string) => {
  const trimmed = phone.trim();
  const digits = trimmed.replace(/\D/g, "");

  if (trimmed.startsWith("+")) return `+${digits}`;
  if (digits.startsWith("00")) return `+${digits.slice(2)}`;
  if (/^47\d{8}$/.test(digits)) return `+${digits}`;
  if (/^\d{8}$/.test(digits)) return `+47${digits}`;
  return digits;
};

export const isValidPhoneNumber = (phone: string) => {
  const e164 = ensureE164Format(phone);
  if (e164.startsWith("+47")) return /^\+47\d{8}$/.test(e164);
  return /^\+[1-9]\d{7,14}$/.test(e164);
};
